export const FETCH_BROKERAGES = 'brokerages/FETCH';
export const FETCH_BROKERAGES_SUCCESS = 'brokerages/FETCH_SUCCESS';
export const FETCH_BROKERAGES_FAILURE = 'brokerages/FETCH_FAILURE';

export const fetchBrokerages = currentUser => {
    return {
        type: FETCH_BROKERAGES,
        value: {
            currentUser
        }
    };
};

export const fetchBrokeragesSuccess = data => {
    return {
        type: FETCH_BROKERAGES_SUCCESS,
        value: data
    };
};

export const fetchBrokeragesFailure = error => {
    return {
        type: FETCH_BROKERAGES_FAILURE,
        value: error
    };
};
